const data = {
  brandTable: {
    columns: [{
      prop: 'index',
      label: '序号'
    }, {
      prop: 'brandId',
      label: '品牌名称'
    }, {
      prop: 'scanCheckNum',
      label: '巡查次数'
    }, {
      prop: 'compliantVehicleNum',
      label: '合法车辆数(已备案-已传数据)'
    }, {
      prop: 'notCompliantVehicleNum',
      label: '非法车辆数(未备案-已传数据)'
    }, {
      prop: 'registeredCount',
      label: '已备案-未传数据车辆数'
    }, {
      prop: 'notRegisteredCount',
      label: '未备案-未传数据车辆数'
    }, {
      prop: 'overDeliveryRate',
      label: '超量投放率'
    }]
  },
  personTable: {
    columns: [{
      prop: 'index',
      label: '序号',
      fixed: 'left'
    }, {
      prop: 'inspectionByName',
      label: '巡查人'
    }, {
      prop: 'scanCheckNum',
      label: '巡查次数',
      fixed: 'left'
    }, {
      prop: 'compliantVehicleNum',
      label: '合法车辆数(已备案-已传数据)'
    }, {
      prop: 'notCompliantVehicleNum',
      label: '非法车辆数(未备案-已传数据)'
    }, {
      prop: 'registeredCount',
      label: '已备案-未传数据车辆数'
    }, {
      prop: 'notRegisteredCount',
      label: '未备案-未传数据车辆数'
    }, {
      prop: 'licenseCode',
      label: '车管所二维码数'
    }, {
      prop: 'invalidCode',
      label: '无效二维码数'
    }]
  }
}
export default data
